var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PDFOMP',{attrs:{"back_as_landing_page":true,"rotta_back":'/home/dashboard'}})
}
var staticRenderFns = []

export { render, staticRenderFns }